<template>
  <v-card v-if="data">
    <slot name="title">
      <v-toolbar color="grey lighten-4" light tile flat>
        <v-toolbar-title centered class="headline font-weight-bold">{{ title }}</v-toolbar-title>
        <div class="flex-grow-1"></div>

        <v-spacer></v-spacer>
      </v-toolbar>
    </slot>

    <v-card-text>
      <v-row>
        <v-col cols="4">
          <key-value title="Id">
            <span class="small" v-text="data.id"></span>
          </key-value>
          <key-value title="Sending Country" :value="data.sending_country.name" />
          <key-value
            title="Sending Min Amount (€)"
            :value="data.sending_country.sending_min_amount"
          />
          <key-value
            title="Sending Max Amount (€)"
            :value="data.sending_country.sending_max_amount"
          />
        </v-col>
        <v-col cols="4">
          <key-value title="Receiving Country" :value="data.receiving_country.name" />
          <key-value
            title="Receiving Min Amount (€)"
            :value="data.receiving_country.receiving_min_amount"
            type="date"
          />
          <key-value
            title="Receiving Max Amount (€)"
            :value="data.receiving_country.receiving_max_amount"
            type="date"
          />
        </v-col>
        <v-col cols="4"> </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    dataCountry: Object,
    title: { default: "Receiving Country details" },
    hideActions: { type: Boolean, default: false },
  },
  data() {
    return {
      isUpdating: false,
    };
  },
  computed: {
    data() {
      return this.dataCountry;
    },
  },
  methods: {},
};
</script>
